import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function tetelekRowRequiredValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;

    return value?.length > 0 ? null : { requiredTetel: true };
  };
}
